<template>
  <div>
    <basic-subheader>
      <template v-slot:filters>
        <div class="p-4">
          <basic-input
            label="Tên khách hàng"
            placeholder="Nhập tên khách hàng"
            name="name"
            class="route-input"
            :value.sync="filter.name"
            @v-modal:update="searchDebounce"
          ></basic-input>
        </div>
      </template>
      <template v-slot:actions>
      </template>
      <!-- <template v-slot:actions>
          <b-button v-if="isInsertPermission" class="btn btn-success mr-2"
            @click="importCustomer">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/File/file-download.svg" />
            </span>
            Import
          </b-button>
          <b-button v-if="isInsertPermission" class="btn btn-success" type="button"
            @click.stop="createCustomerReceive">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
            </span>
            Thêm mới
          </b-button>
          <modal-import @import-success="loadData(true)" />
        </template> -->
    </basic-subheader>
    <b-overlay>
      <template>
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :searchAction="false"
                  :selectAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td>
                      {{ item.name }}
                      <span v-if="item.zaloGroupId === 'NO_ZALO_GROUP'" class="badge-no-zalo">Không nhóm</span>
                      <span v-else-if="sharedZaloGroupCount(item) > 1 || isSharedZaloGroup(item)"
                        class="badge-shared-group" :title="`Nhóm Zalo: ${item.zaloGroupId}`">Nhóm chung</span>
                    </td>
                    <td style="width: 5px">
                      <action-dropdown
                        :value="item"
                        :show_copy="false"
                        :show_delete="false"
                        :show_edit="false"
                        :show_view="false"
                      >
                        <template>
                          <b-dropdown-text
                            tag="div"
                            class="navi-item cursor-pointer"
                            @click="moveProcessTab(item)"
                          >
                            <a class="navi-link text-primary">
                              <span class="menu-icon svg-icon svg-icon-sm">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/flag.svg"
                                />
                              </span>
                              <span class="navi-text text-primary"
                                >Trờ về tiếp nhận</span
                              >
                            </a>
                          </b-dropdown-text>

                          <b-dropdown-divider
                            v-if="isDeletePermission"
                          ></b-dropdown-divider>
                          <b-dropdown-text
                            v-if="isDeletePermission"
                            tag="div"
                            class="navi-item cursor-pointer"
                            @click="deleteCustomer(item)"
                          >
                            <a class="navi-link text-danger">
                              <span class="menu-icon svg-icon svg-icon-sm">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/power.svg"
                                />
                              </span>
                              <span class="navi-text text-danger"
                                >Xóa dữ liệu</span
                              >
                            </a>
                          </b-dropdown-text>
                        </template>
                      </action-dropdown>
                    </td>
                    <td>
                      <span v-if="item.isZaloLinked === true" class="badge-login-type badge-zalo">Zalo</span>
                      <span v-else-if="item.isZaloLinked === false" class="badge-login-type badge-google"><img src="/media/svg/logos/google-icon.svg" class="badge-google__icon" alt="" />Google</span>
                      <span v-else>{{ item.phoneNumber }}</span>

                      <span
                        v-if="item.isZaloLinked == null"
                        class="svg-icon"
                        @click="handleCall(item)"
                      >
                        <inline-svg
                          src="/media/svg/icons/Neolex/Call/call-phone.svg"
                        />
                      </span>
                    </td>

                    <td>
                      {{
                        item.gender === 1
                          ? 'Nam'
                          : item.gender === 2
                          ? 'Nữ'
                          : 'Khác'
                      }}
                    </td>
                    <td>
                      {{ item.birthYear }}
                    </td>
                    <td>
                      {{ getNameOf('coach', item.coachId) }}
                    </td>
                    <td>
                      {{ item.contactSource }}
                    </td>

                    <td>
                      <a @click="changeReasonOutItem(item)">
                        {{ stripHtml(item.reasonOut) }}
                      </a>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-modal
      id="reactive-modal"
      ref="reactive-modal"
      title="Xác nhận hành động"
      size="sd"
      hide-footer
    >
     Bạn đang thao tác chuyển khác hàng về danh sách tiềm năng.
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button
            class="btn btn-success ml-2"
            href="#"
            @click.stop="handleSuccessOk(currentItem)"
            tabindex="0"
            :disabled="isSubmitting"
          >         
            Tiếp tục
          </b-button>
        <b-button
          class="btn btn-plain ml-2"
          href="#"
          @click.stop="handleCancel"
          tabindex="0"
        >
          Đóng
        </b-button>


      </div>
    </b-modal>
      </template>
    </b-overlay>
    <call-client :targetItem="currentItem" @load-data="loadData" />
    <reason-question
      :targetItem="currentItem"
      :title="currentTitle"
      @load-data="loadData"
    />
    <modal-detail :targetItem="currentItem" />
    <modal-accept :targetItem="currentItem" />
    <modal-create @load-data="loadData" />
  </div>

 
</template>

<script>
// import DatePicker from 'vue2-datepicker';
import moment from 'moment-timezone';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('customerReceives');

export default {
  name: 'CustomerReceiveTab',
  components: {
   // 'date-picker': DatePicker,
    'call-client': () => import('./CallModal.vue'),
    'reason-question': () => import('./ReasonModal.vue'),
    //   'modal-import': () => import('./ImportModal.vue'),
    'modal-create': () => import('./CreateModal.vue'),
    'modal-accept': () => import('./AcceptModal.vue'),
    'modal-detail': () => import('./DetailModal.vue'),
  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      data: [],
      statuses: [
        {
          text: 'Từ chối',
          value: 0,
        },
        {
          text: 'Xác nhận tham gia',
          value: 1,
        },
      ],
      coaches: [],
      courses: [],
      genders: [],
      sort: {
        by: null,
        order: null,
      },
      column: [
        {
          key: 'name',
          label: 'Khách hàng',
          sortable: false,
        },
        {
          key: 'actionDropdown',
          label: '',
          sortable: false,
        },
        {
          key: 'phoneNumber',
          label: 'Số điện thoại',
          sortable: false,
        },

        {
          key: 'gender',
          label: 'Giới tính',
          sortable: false,
        },
        {
          key: 'dateOfBirth',
          label: 'Năm sinh',
          sortable: false,
        },

        {
          key: 'coach',
          label: 'Coach phụ trách',
          sortable: false,
        },
        {
          key: 'contactSource',
          label: 'Nguồn tiếp nhận',
          sortable: false,
        },
        {
          key: 'reasonOut',
          label: 'Ghi chú',
          sortable: false,
        },
        
      ],
      filter: {
        name: null,
        phoneNumber: null,
        gender: null,
        dateOfBirth: null,
        contactSource: null,
        status: 9,
        coachId: null,
        reasonOut: null,
        createDatetime: [
          moment().format('MM/DD/YYYY'),
          moment().format('MM/DD/YYYY'),
        ],
      },
      currentItem: {},
      currentTitle: null,
      filterNoZalo: false,
    };
  },
  computed: {
    // Đếm khách dùng chung một nhóm Zalo trong trang hiện tại, theo zaloGroupId
    zaloGroupCounts() {
      const counts = {};
      (this.data || []).forEach((row) => {
        const groupId = row && row.zaloGroupId;
        if (!groupId || groupId === 'NO_ZALO_GROUP') return;
        counts[groupId] = (counts[groupId] || 0) + 1;
      });
      return counts;
    },
    searchParams() {
      const payload = this.removeEmpty({
        name: this.filter.name,
        status: this.filter.status,
        genders: this.filter.genders,
        coachId: this.filter.coachId,
        contactSource: this.filter.contactSource,
        page: this.paging.page,
        size: this.paging.pageSize,
        startDate: moment(this.filter.createDatetime[0]).format('MM/DD/YYYY'),
        dueDate: moment(this.filter.createDatetime[1]).format('MM/DD/YYYY'),
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },

  methods: {
    ...mapActions(['setCourses', 'setCoaches']),
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      this.filter.name = null;
      this.filter.phoneNumber = null;
      this.filter.gender = null;
      this.filter.status = null;
      this.filter.coachId = null;
      this.filter.contactSource = null;

      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    createCustomerReceive() {
      this.$bvModal.show('create-modal');
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data, meta } = await this.$api.get('CustomerReceives', {
          params: this.searchParams,
        });

        let filteredData = data || [];
        if (this.filterNoZalo) {
          filteredData = filteredData.filter((el) => el.zaloGroupId === 'NO_ZALO_GROUP');
        }

        this.data =
          filteredData?.map((el) => {
            return {
              ...el,
            };
          }) || [];
        this.paging.total = meta.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async getSearchDataPrepare() {
      await this.$api
        .get('CustomerReceives/PrepareSearchFormItem')
        .then(({ data }) => {
          const { coaches } = data;
          this.coaches = coaches?.map((c) => {
            return {
              text: c?.coachName,
              value: c?.coachId,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
          return Promise.reject(error);
        });
    },
    async getDataCourses() {
      await this.$api
        .get('Courses')
        .then(({ data }) => {
          const { items } = data;
          this.courses = items?.map((c) => {
            return {
              text: c?.name,
              value: c?.id,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
          return Promise.reject(error);
        });
    },
    handleCall(item) {
      this.currentItem = item;
      this.$bvModal.show('call-modal');
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      // Create a new FormData object
      const formData = new FormData();

      // Append gender separately with proper value check
      if (item.gender === 1 || item.gender === 2) {
        formData.append('gender', item.gender);
      }

      // Append properties of the item object to formData
      Object.keys(item).forEach((key) => {
        if (key == 'isDeleted') {
          formData.append('isDeleted', !!item.isDeleted);
        } else if (key === 'timeAccepted' || key === 'gender') {
          // Skip - gender handled above
        } else formData.append(key, item[key]);
      });

      try {
        await this.$api.put(`/CustomerReceives/${item.id}`, formData);
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
      } catch (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
      this.loadData();
    },
    searchDebounce(value) {
      this.filter.name = value;
      this.resetPaging();
    },
    searchDate() {
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    importCustomer() {
      this.$bvModal.show('modal-import');
    },
    // Nhom Zalo dung chung (gan tu man import) -> badge "Nhom chung".
    // Uu tien co tu BE; khong co co thi khong hien badge de tranh bao sai.
    sharedZaloGroupCount(item) {
      const groupId = item && item.zaloGroupId;
      if (!groupId || groupId === 'NO_ZALO_GROUP') return 0;
      return this.zaloGroupCounts[groupId] || 0;
    },
    isSharedZaloGroup(item) {
      if (!item) return false;
      if (item.isSharedZaloGroup === true) return true;
      return (
        !!item.zaloGroupId &&
        item.zaloGroupId !== 'NO_ZALO_GROUP' &&
        item.bypassCreateZaloGroup === true
      );
    },
    confirmItem(item) {
      this.currentItem = item;
      this.$bvModal.show('accept-modal');
    },
    moveToPotentialItem(item) {
      this.currentItem = item;
      this.currentTitle = 'Ghi chú';
      this.$bvModal.show('reason-modal');
    },
    getNameOf(key, value) {
      switch (key) {
        case 'coach':
          return (
            this.coaches?.find((item) => item.value == value)?.text ?? null
          );
      }
    },
    changeReasonOutItem(item) {
      this.currentItem = item;
      this.currentTitle = 'Ghi chú';
      this.$bvModal.show('reason-modal');
    },
    moveProcessTab(item) {
      this.currentItem = item;
      this.currentTitle = 'Ghi chú';
      this.$bvModal.show('reactive-modal');
    },
    deleteCustomer(item) {
      this.$swal({
        title: '',
        text: `Dữ liệu của khách hàng "${item.name}" sẽ bị xóa vĩnh viễn khỏi hệ thống và không thể khôi phục. Bạn có chắc chắn muốn xóa không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `Xóa vĩnh viễn`,
            value: true,
            visible: true,
            className: `btn btn-inactive`,
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (!result) return;
          try {
            await this.$api.delete(`CustomerReceives/HardDelete/${item.id}`);
            this.loadData();
            this.$toastr.s({
              title: 'Thành công !',
              msg: 'Đã xóa vĩnh viễn dữ liệu khách hàng.',
            });
          } catch (error) {
            this.$toastr.e({
              title: 'Lỗi !',
              msg: error.message || 'Không xóa được khách hàng.',
            });
          }
        }.bind(this),
      );
    },
    detailCustomer(item) {
      this.currentItem = item;
      this.$bvModal.show('customer-receive-detail-modal');
    },
    stripHtml(html) {
      // Create a temporary element and use the browser to strip tags
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    async handleSuccessOk(item) {
      this.loading = true;
      this.$store.commit('context/setLoading', true);

      var payload = {
       id: item.id
      };

      try {
        await this.$api.put(
          `/CustomerReceives/reactive/${item.id}`,
          payload,
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 60000,
          },
        );
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
        this.loading = false;
      } catch (error) {
        if (error) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
      } finally {
      //  this.$emit('load-data');
      this.loadData();
      this.$bvModal.hide('reactive-modal');
      this.$store.commit('context/setLoading', false);

      }
    

    },
    async handleCancel()
    {
      this.$bvModal.hide('reactive-modal');
    }
  },

  async created() {
    await Promise.all([
      this.loadData(),
      this.getSearchDataPrepare(),
      this.getDataCourses(),
    ])
      .then(() => {
        this.setCourses(this.courses);
        this.setCoaches(this.coaches);
      })
      .catch(() => {});
  },
};
</script>

<style lang="scss" scoped>

.badge-login-type {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
}

// Dung dung mau/kieu cua nut dang nhap that tung ben, khong phai mau tuy chon:
//  - Zalo: nen xanh duong thuong hieu #0068FF, chu trang - dung nhu nut cua ho.
//  - Google: nen trang, vien xam, kem icon G 4 mau that - dung nhu nut "Sign in with Google".
.badge-zalo {
  background: #0068ff;
  color: #fff;
  letter-spacing: 0.02em;
}

.badge-google {
  background: #fff;
  color: #3c4043;
  border: 1px solid #dadce0;
  font-weight: 600;

  &__icon {
    width: 11px;
    height: 11px;
    margin-right: 4px;
  }
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #00c7f9;
  }

  &.warning-color {
    background-color: #ff5756;
  }
}

.customer-list-page__body__tabs::v-deep {
  margin: 0 -2rem -2rem;

  a.nav-link {
    border: 0;

    &.active {
      font-weight: 600;
      color: #01645a !important;
      border-bottom: 2px solid #01645a;
    }
  }

  li.nav-item {
    a.nav-link:hover {
      color: #333;
    }
  }

  .tab-content {
    display: none;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}

.mw-400 {
  min-width: 400px;
}

.mw-150 {
  min-width: 150px;
}

.mw-200 {
  min-width: 200px;
}

.mw-250 {
  min-width: 250px;
}

.w-40 {
  width: 40px;
}

.mw-157 {
  width: 157px;
}

.confirm {
  color: #003af9;
}

.refuse {
  color: #ff5756;
}

.text-black {
  color: #333;
}

.badge-no-zalo {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(139, 92, 246, 0.12);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.3);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}

.badge-shared-group {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(37, 154, 187, 0.12);
  color: #1b7f9c;
  border: 1px solid rgba(37, 154, 187, 0.35);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}
</style>
